import { Routes, Route, Navigate } from 'react-router-dom'
import { publicRoutes, mainRoutes } from '@/pages/routes'
import { AuthorisePassport, LocalStorageProvider, NotificationWrapper } from '@/processes'
import './styles/main.scss'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css'
import ScrollToTop from '@/components/entrance/ScrollToTop' // theme css file
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import MainLayout from '@/widgets/templates/MainLayout'
import PublicLayout from '@/widgets/templates/PublicLayout'

export const App = () => {
	const {
		t,
		i18n: { language, changeLanguage },
	} = useTranslation()
	const storedLanguage = localStorage.getItem('lang')
	useEffect(() => {
		if (storedLanguage && storedLanguage !== language) {
			changeLanguage(storedLanguage)
		}
	}, [])
	document.title = t('portal_employment_source')
	return (
		<LocalStorageProvider>
			<AuthorisePassport>
				<NotificationWrapper>
					<ScrollToTop />
					<Routes>
						<Route element={<PublicLayout />}>
							{publicRoutes.map(({ path, element }) => (
								<Route key={path} path={path} element={element} />
							))}
						</Route>
						<Route element={<MainLayout />}>
							{mainRoutes.map(({ path, element }) => (
								<Route key={path} path={path} element={element} />
							))}
						</Route>
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				</NotificationWrapper>
			</AuthorisePassport>
		</LocalStorageProvider>
	)
}
